import React, { useState, useEffect } from "react";
import {
  Container,
  Typography,
  Card,
  CardContent,
  Button,
  Grid,
  Snackbar,
} from "@mui/material";
import MuiAlert from "@mui/material/Alert";
import "./style.css";
// import logo from "../../../imgs/logo-final.png"; // Removed
import ResetPasswordForm from "../../molecules/ResetPasswordForm";
import { useNavigate, useLocation } from "react-router-dom";
import {verifyForgotToken,resetPassword,} from "../../../api/services/services";
import successImg from "../../../imgs/succes.svg";

const ResetPasswordPage = () => {
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const navigate = useNavigate();
  const [isCreate, setIsCreate] = useState(true);
  const [success, setSuccess] = useState(false);

  const location = useLocation();
  const urlData = new URLSearchParams(location.search);
  const token = urlData.get("token");

  const [isValid, setIsValid] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  const handleCloseSnackbar = () => {
    setOpenSnackbar(false);
  };

  //
  const handleResetPassword = (formData) => {
    console.log("Reset Password Data:", formData);
    const body = {
      password: formData.password,
      passwordConfirmation: formData.confirmPassword,
    };

    resetPassword(token, body)
      .then((response) => {
        setIsValid(true);
        setIsCreate(false);
        setSuccess(true);
      })
      .catch((error) => {
        console.error("Error resetting password:", error);
        if (error.response.data.statusCode == 1002) {
          setSnackbarMessage("Token has been expired");
          setOpenSnackbar(true);
        } else {
          setSnackbarMessage(error.response.data.message);
          setOpenSnackbar(true);
        }
      });
  };

  useEffect(() => {
    verifyForgotToken(token)
      .then((response) => {
        setIsValid(true);
        setIsLoading(false);
      })
      .catch((error) => {
        setIsLoading(false);
        console.error("Error verifying token:", error.response.data);
        if (error.response.data.statusCode == 1002) {
          setSnackbarMessage("Token has been expired");
          setOpenSnackbar(true);
        } else {
          setSnackbarMessage(error.response.data.message);
          setOpenSnackbar(true);
        }
      });
  }, []);

  return (
    <>
      {isValid ? (
        <div className="login-split-container">
          {/* Left Panel: The Brand Experience */}
          <div className="brand-panel">
            <div className="brand-content">
              <Typography variant="h1" className="brand-title">
                Shelozon Digital
              </Typography>
              <Typography variant="h5" className="brand-tagline">
                 Secure your future.
              </Typography>
            </div>
          </div>

          {/* Right Panel: The Functional Form */}
          <div className="form-panel">
            <Container maxWidth="xs" className="form-container">
              {isCreate && (
                <>
                  <div className="form-header">
                    <Typography variant="h4" className="form-title">
                       Reset Password
                    </Typography>
                    <Typography variant="body1" className="form-desc">
                       Create your new password to continue
                    </Typography>
                  </div>
                  
                  <ResetPasswordForm onSubmit={handleResetPassword} />
                </>
              )}

              {success && (
                <div className="success-container">
                    <img
                      src={successImg}
                      alt="success"
                      width="84"
                      height="84"
                      className="mb-4"
                    />
                    <Typography variant="h5" className="success-title">
                        Password Reset
                    </Typography>
                    <Typography variant="body1" className="form-desc mb-5">
                        Your new password has been set successfully.
                    </Typography>
                    <Button
                      type="submit"
                      variant="contained"
                      className="submit-btn"
                      onClick={() => navigate("/login")}
                      fullWidth
                    >
                      Return to Login
                    </Button>
                </div>
              )}
            </Container>
          </div>
        </div>
      ) : (
        <>
          {isLoading ? (
            <div className="d-flex justify-content-center align-items-center vh-100">
               <Typography>Loading...</Typography>
            </div>
          ) : (
             <div className="d-flex justify-content-center align-items-center vh-100 flex-column">
               <Typography variant="h5" gutterBottom>Link Expired or Invalid</Typography>
               <Button onClick={() => navigate('/forget-password')}>Request New Link</Button>
            </div>
          )}
        </>
      )}

      <Snackbar
        open={openSnackbar}
        autoHideDuration={6000} // Adjust the duration as needed
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <MuiAlert
          elevation={6}
          variant="filled"
          severity={
            snackbarMessage?.includes("successful") ? "success" : "error"
          }
          onClose={handleCloseSnackbar}
        >
          {snackbarMessage}
        </MuiAlert>
      </Snackbar>
    </>
  );
};

export default ResetPasswordPage;
